import { useEffect, useState } from "react";
import Loader2 from "../common/Loader2";
import { getErrorListService, getOrderListService } from "../../services/ticketService";
import { ChevronDownIcon } from "lucide-react";

export default function LogTicketForm({ onSubmit }: { onSubmit: (data: any) => void }) {
  const [shortDescription, setShortDescription] = useState("");
  const [longDescription, setLongDescription] = useState("");
  const [category, setCategory] = useState("");
  const [subCategory, setSubCategory] = useState("");
  const [transactionId, setTransactionId] = useState("");
  const [file, setFile] = useState<File | null>(null);
  const [loading, setLoading] = useState(false);
  const [orders, setOrders] = useState<any[]>([]);
  const [errors, setErrors] = useState<any[]>([]);
  const [formIsComplete, setFormIsComplete] = useState(false); 
  const [isInAppIssue, setIsInAppIssue] = useState(false); 
  const [preview, setPreview] = useState<string | null>(null);
  useEffect(() => {
    checkForm();
  }, [file]);

  useEffect(() => {
    async function fetchTickets() {
      try {
        setLoading(true);
        const response = await getOrderListService();
        if (response.success) {
          setOrders(response.message.my_loans || []);
        }

        const response2 = await getErrorListService();
        if (response2.success) {
          setErrors(response2.message.error_list || []);
        }
      } catch (err) {
        console.log("Failed to fetch tickets.");
      } finally {
        setLoading(false);
      }
    }
    fetchTickets();
  }, []);

  const onClickEvent = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      setLoading(true);
      const formData = new FormData();
      if (file) formData.append("file", file);
      formData.append("transaction_id", transactionId);
      formData.append("category", category);
      formData.append("sub_category", subCategory);
      formData.append("short_description", shortDescription);
      formData.append("long_description", longDescription);
      onSubmit(formData);
    } catch (err) {
      console.error("Error submitting ticket:", err);
    } finally {
      setLoading(false);
    }
  };

  // ✅ Form validation logic
  const isFormValid =
    shortDescription.trim() !== "" &&
    longDescription.trim() !== "" &&
    transactionId.trim() !== "" &&
    file !== null;

const checkForm = () => {
    console.log(shortDescription)
    console.log(longDescription)
    console.log(category)
    console.log(subCategory)
    console.log(transactionId)
    console.log(file)
    if(shortDescription.trim() !== "" &&
    longDescription.trim() !== "" &&
    transactionId.trim() !== "" &&
    file !== null){
        console.log("1")
      setFormIsComplete(true)
    }else{
        console.log("2")
      setFormIsComplete(false)
    }
  }

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-[#f5f9ff]">
        <Loader2 />
      </div>
    );
  }

  return (
    <form onSubmit={onClickEvent} className="space-y-4">
      <h2 className="text-xl font-semibold text-gray-800">Log a Ticket</h2>

      <div className="space-y-12">
        <div className="border-b border-gray-900/10 pb-12">
          <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">

            {/* Orders Dropdown */}
            <div className="col-span-full">
              <label className="block text-sm font-medium text-gray-900">Order</label>
              <div className="mt-2 grid grid-cols-1 relative">
                <select
                  value={transactionId}
                  onKeyUp={(e) => isFormValid}
                  onChange={(e) => {
                        setTransactionId(e.target.value)
                        console.log(e.target.value)
                        if(e.target.value == "issueNotListed")
                          setIsInAppIssue(true)
                        else 
                          setIsInAppIssue(false)
                    }}
                  className="w-full appearance-none rounded-md bg-white py-1.5 pl-3 pr-8 text-base text-gray-900 outline outline-1 outline-gray-300 focus:outline-indigo-600 sm:text-sm"
                  required
                >
                  <option value="">Select an order</option>
                  {orders.map((order, idx) => (
                    <option key={idx} value={order.transaction_id}>
                      {order.order_id} - {order.loan_status}
                    </option>
                  ))}
                </select>
                <ChevronDownIcon className="pointer-events-none absolute right-2 top-2.5 size-5 text-gray-500" />
              </div>
            </div>
            
            {!isInAppIssue && (
            <div className="col-span-full">
              <label className="block text-sm font-medium text-gray-900">Issue</label>
              <select
                value={`${category}-${subCategory}`}
                onChange={(e) => {
                    const [cat, subCat] = e.target.value.split("-"); // 👈 split on "-"
                    setCategory(cat);
                    setSubCategory(subCat);
                }}
                onKeyUp={(e) => checkForm()}
                className="w-full rounded-md bg-white py-1.5 pl-3 pr-8 text-base text-gray-900 outline outline-1 outline-gray-300 focus:outline-indigo-600 sm:text-sm"
                required
              >
                <option value="">Select an Issue</option>
                {errors.map((error, idx) => (
                  <option key={idx} value={`${error.category}-${error.sub_category}`}>
                    {error.sub_category} - {error.description}
                  </option>
                ))}
              </select>
            </div>
            )}

            {/* Short Description */}
            <div className="col-span-full">
              <label className="block text-sm font-medium text-gray-900">Short Description</label>
              <input
                type="text"
                value={shortDescription}
                onKeyUp={(e) => checkForm()}
                onChange={(e) => setShortDescription(e.target.value)}
                className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 focus:outline-indigo-600 sm:text-sm"
                required
              />
            </div>

            {/* Long Description */}
            <div className="col-span-full">
              <label className="block text-sm font-medium text-gray-900">Long Description</label>
              <textarea
                rows={3}
                value={longDescription}
                onKeyUp={(e) => checkForm()}
                onChange={(e) => setLongDescription(e.target.value)}
                className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 focus:outline-indigo-600 sm:text-sm"
                required
              />
            </div>

            {/* File Upload */}
            <div className="col-span-full">
              {/* Label */}
              <label className="block text-sm font-medium text-gray-900">Image</label>

              {/* File Input */}
              <input
                type="file"
                name="file"
                accept="image/*"
                onChange={(e) => {
                  const selectedFile = e.target.files?.[0];

                  if (selectedFile) {
                    // Check if file is an image
                    if (!selectedFile.type.startsWith("image/")) {
                      alert("Only image files are allowed!");
                      e.target.value = ""; // reset input
                      setFile(null);
                      setPreview(null);
                      return;
                    }

                    // Check if file size < 1MB
                    if (selectedFile.size > 1024 * 1024) {
                      alert("File size must be less than 1MB!");
                      e.target.value = ""; // reset input
                      setFile(null);
                      setPreview(null);
                      return;
                    }

                    setFile(selectedFile);
                    setPreview(URL.createObjectURL(selectedFile)); // ✅ set preview
                    checkForm();
                  }
                }}
                className="mt-2 block w-full text-sm text-gray-600"
                required
              />

              {/* Image Preview */}
              {preview && (
                <div className="mt-3">
                  <img
                    src={preview}
                    alt="Preview"
                    className="w-32 h-32 object-cover rounded-lg border"
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <button
        type="submit"
        disabled={!formIsComplete}
        className={`rounded px-4 py-2 text-white ${
          isFormValid ? "bg-blue-600 hover:bg-blue-700" : "bg-gray-400 cursor-not-allowed"
        }`}
      >
        Submit Ticket
      </button>
    </form>
  );
}
